/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Validation_Error_Go_BackInputs */

const en_validation_error_go_back = /** @type {(inputs: Validation_Error_Go_BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Go back`)
};

const nl_validation_error_go_back = /** @type {(inputs: Validation_Error_Go_BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ga terug`)
};

/**
* | output |
* | --- |
* | "Go back" |
*
* @param {Validation_Error_Go_BackInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const validation_error_go_back = /** @type {((inputs?: Validation_Error_Go_BackInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Validation_Error_Go_BackInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_validation_error_go_back(inputs)
	return en_validation_error_go_back(inputs)
});